import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core'

type Option = {
  label: string
  value: number | string
}
@Component({
  selector: 'radio',
  templateUrl: './radio.component.html',
  styleUrls: ['./radio.component.css'],
})
export class RadioComponent implements OnInit {
  @Input() public value: any
  @Input() public name: string
  @Input() public ngClass?: any
  @Input() public controlled?: boolean = false
  @Input() public options: Option[]
  @Output() public onChange: EventEmitter<any> = new EventEmitter()

  constructor() {}

  ngOnInit() {}
}
